import { FC, ReactNode } from 'react'

import { CompanyOption, CompanyOptionType } from './Option'
import { CompanyTag, CompanyTagType } from './Tag'

import { Form, FormType } from './form/Form'

export const Company: FC &
  CompanyTagType &
  CompanyOptionType &
  FormType = (): ReactNode => <></>

Company.Tag = CompanyTag
Company.Option = CompanyOption
Company.Form = Form
